import {useUniversalContext} from "@cxc/react-universal-components";
import {useEffect} from "react";
import {track} from "./generateDigitalData";
import {getLanguageAndCountry} from "./useLocale";

export const useAnalytics = () => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { language: locale }: { language: string } = useUniversalContext()
  const languageCountryPair = getLanguageAndCountry(locale)

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const {subscribeScopedValue} = useUniversalContext();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-assignment
  const isAnalyticsLoaded = subscribeScopedValue("fpg_analytics", "isLoaded");
  useEffect(() => {
    track("globalLoad", languageCountryPair)
  }, [isAnalyticsLoaded])
}
